<!-- Address Selector with Popover + Command -->
<div class="address-selector-container">
  <!-- Label — omitted when the host dialog already renders one -->
  @if (label()) {
    <label hlmLabel class="mb-1.5 block">{{ label() }}</label>
  }

  <!-- Popover Container -->
  <brn-popover
    #popover
    sideOffset="5"
    (stateChanged)="onPopoverOpenChange($event === 'open')"
  >
    <!-- Trigger Button -->
    <button
      class="ks-select-trigger"
      [disabled]="disabled() || isLoading()"
      brnPopoverTrigger
    >
      <span class="truncate">
        @if (isLoading()) {
        <span class="flex items-center gap-2">
          <div
            class="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"
          ></div>
          Lädt...
        </span>
        } @else {
        {{ getSelectedAddressDisplay() }}
        }
      </span>
      <ng-icon name="lucideChevronDown" class="w-4 h-4"></ng-icon>
    </button>

    <!-- Command Content -->
    <div
      hlmPopoverContent
      class="ks-menu-panel w-full min-w-[400px] p-0"
      *brnPopoverContent="let ctx"
    >
      <hlm-command [filter]="filterAddress">
        <!-- Search -->
        <hlm-command-search>
          <ng-icon
            hlm
            name="lucideSearch"
            class="shrink-0 opacity-50"
          ></ng-icon>
          <input
            type="text"
            hlm-command-search-input
            placeholder="Adresse suchen"
            (input)="onSearchInput($any($event.target).value)"
          />
        </hlm-command-search>

        @if (hasHiddenAddresses()) {
          <p class="px-3 py-2 text-xs text-muted-foreground border-b">
            {{ addresses().length }} von {{ totalCount() }} Adressen geladen — tippen,
            um die übrigen {{ hiddenAddressCount() }} zu durchsuchen.
          </p>
        }

        <hlm-command-list>
          <!-- Error State -->
          @if (error()) {
          <p class="px-3 py-3 text-xs leading-normal text-destructive">{{ error() }}</p>
          }

          @if (searching()) {
            <p role="status" class="px-3 py-3 text-xs text-muted-foreground">Adressen werden gesucht…</p>
          }
          <!-- Addresses Section -->
          @if (!error() && !searching()) { @if (addresses() && addresses().length > 0) {
          <!-- Addresses Group -->
          <hlm-command-group>
            <hlm-command-group-label
              >Verfügbare Adressen</hlm-command-group-label
            >

            @for (address of addresses(); track address.addressId) {
            <button
              hlm-command-item
              [value]="getAddressSearchValue(address)"
              [style.background-color]="selectedAddressId() === address.addressId ? null : 'transparent'"
              [class.bg-accent]="selectedAddressId() === address.addressId"
              (click)="selectAddress(address)"
            >
              <ng-icon hlm name="lucideMapPin" hlmCommandIcon></ng-icon>
              <div class="flex-1 text-left">
                <p class="text-sm font-normal truncate">
                  {{ address.street }} {{ address.houseNumber }}
                </p>
                <p class="text-xs text-muted-foreground truncate">
                  {{ address.postalCode }} {{ address.city }},
                  {{ address.country }}
                </p>
                <div class="flex gap-1 mt-1">
                  @if (address.isApartmentBuilding) {
                  <span
                    class="ks-chip"
                  >
                    Mehrfamilienhaus
                  </span>
                  } @if (address.hasSolar) {
                  <span
                    class="ks-chip"
                  >
                    Solar vorhanden
                  </span>
                  }
                </div>
              </div>
              @if (selectedAddressId() === address.addressId) {
              <ng-icon
                hlm
                name="lucideCheck"
                class="w-4 h-4 text-primary flex-shrink-0"
              ></ng-icon>
              }
            </button>
            }
          </hlm-command-group>
          } @else if (!isLoading()) {
          <!-- Empty state -->
          <div *brnCommandEmpty hlmCommandEmpty>{{ searchTerm() ? 'Keine passenden Adressen gefunden' : 'Keine Adressen vorhanden' }}</div>
          } }
        </hlm-command-list>

        <!-- Footer: Create New Address (always visible, outside command filtering) -->
        @if (!isLoading() && !error()) {
        <div class="border-t border-border bg-muted/30">
          <button
            class="flex w-full items-center gap-3 px-3 py-2 text-sm hover:bg-accent hover:text-accent-foreground transition-colors"
            (click)="onCreateNewAddress()"
          >
            <ng-icon name="lucidePlus" class="w-4 h-4 text-primary"></ng-icon>
            <span class="font-normal">Neue Adresse hinzufügen</span>
          </button>
        </div>
        }
      </hlm-command>
    </div>
  </brn-popover>
</div>
